import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
  FiHome, FiPhone, FiBarChart2, FiUsers, FiSettings, FiLogOut, FiMenu, FiX,
  FiTrendingUp, FiPhoneForwarded, FiDollarSign, FiCheckSquare, FiTag, FiBookOpen, FiFileText,
} from 'react-icons/fi';
import SoftphoneWidget from '../softphone/SoftphoneWidget';
import './admin.css';

const navItems = [
  { path: '/admin', icon: FiHome, label: 'Bosh sahifa', end: true },
  { path: '/admin/calls', icon: FiPhone, label: "Qo'ng'iroqlar jurnali" },
  { path: '/admin/stats', icon: FiBarChart2, label: 'Statistikalar' },
  { path: '/admin/note-analytics', icon: FiFileText, label: 'Izohlar tahlili' },
  { path: '/admin/operators', icon: FiUsers, label: 'Operatorlar' },
  { path: '/admin/productivity', icon: FiTrendingUp, label: 'Unumdorlik' },
  { path: '/admin/contacts', icon: FiUsers, label: 'Kontaktlar' },
  { path: '/admin/deals', icon: FiDollarSign, label: 'Bitimlar' },
  { path: '/admin/tasks', icon: FiCheckSquare, label: 'Vazifalar' },
  { path: '/admin/dispositions', icon: FiTag, label: 'Natija kodlari' },
  { path: '/admin/knowledge', icon: FiBookOpen, label: 'Bilim bazasi' },
  { path: '/admin/forwarding', icon: FiPhoneForwarded, label: "Yo'naltirish" },
  { path: '/admin/settings', icon: FiSettings, label: 'Sozlamalar' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Yon panel ochiq turganda orqa fon aylanmasin (telefonda chalkashtiradi).
  useEffect(() => {
    document.body.classList.toggle('adm-locked', sidebarOpen);
    return () => document.body.classList.remove('adm-locked');
  }, [sidebarOpen]);

  // Esc — yon panelni yopadi.
  useEffect(() => {
    if (!sidebarOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setSidebarOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [sidebarOpen]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const now = new Date();

  return (
    <div className="adm">
      <div
        className={`adm-ov${sidebarOpen ? ' on' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      <aside className={`adm-side${sidebarOpen ? ' open' : ''}`}>
        <div className="adm-side-head">
          <div className="adm-logo">
            <div className="adm-logo-ic"><FiPhone size={18} /></div>
            <div style={{ minWidth: 0 }}>
              <div className="adm-logo-tx">AUD-IT SOFT</div>
              <div className="adm-logo-sub">Call Center</div>
            </div>
          </div>
          <button className="adm-xmob" onClick={() => setSidebarOpen(false)} title="Yopish">
            <FiX size={20} />
          </button>
        </div>

        <nav className="adm-nav">
          {navItems.map(({ path, icon: Icon, label, end }) => (
            <NavLink
              key={path}
              to={path}
              end={end}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="adm-side-foot">
          <div className="adm-user">
            <div className="adm-avatar">{user?.full_name?.[0] || 'A'}</div>
            <div style={{ minWidth: 0 }}>
              <div className="adm-user-n">{user?.full_name}</div>
              <div className="adm-user-r">Administrator</div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-ghost btn-sm"
            style={{ width: '100%', justifyContent: 'center', color: 'var(--danger)' }}
          >
            <FiLogOut size={16} /> Chiqish
          </button>
        </div>
      </aside>

      <main className="adm-main">
        <header className="adm-top">
          <button className="adm-burger" onClick={() => setSidebarOpen(true)} title="Menyu">
            <FiMenu size={22} />
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginLeft: 'auto' }}>
            <span className="adm-date adm-date-long">
              {now.toLocaleDateString('uz-UZ', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
            </span>
            <span className="adm-date adm-date-short">
              {now.toLocaleDateString('uz-UZ', { day: '2-digit', month: '2-digit', year: 'numeric' })}
            </span>
          </div>
        </header>

        {/* Kiruvchi qo'ng'iroq kartasi shu yerda suzadi (balandligi nol). */}
        <div id="cc-callbar-slot" className="adm-callbar" />

        <div className="adm-content">
          <Outlet />
          <SoftphoneWidget />
        </div>
      </main>
    </div>
  );
}
